module.exports = __webpack_public_path__ + "static/img/back.aad5fcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/back.png
// module id = P9/e
// module chunks = 4